const EPSILON = 0.00001;

/**
 * Returns true if given value is approximately equal to the given
 * reference.
 *
 * @param value Value to be compared
 * @param reference Value where the comparison will be based
 */
export const approximatelyEqual = (value: number, reference: number) => (
  Math.abs(value - reference) < EPSILON * Math.max(1.0, Math.abs(value), Math.abs(reference))
);
